import React from 'react';
import Head from 'next/head';
import StudioWrapper from '../StudioWrapper';
import ClaytonLogo from './clayton_logo.jpg';
import NotFoundContent from '../../NotFound/NotFoundContent';

const NotFound = () => {
  return (
    <StudioWrapper>
      <div className="constrained-width">
        <Head>
          <title>Not Found | Clayton Studio</title>
          <meta
            name="description"
            content="Clayton has been providing affordable, quality homes since 1956. Learn more about our recent company announcements and publicly released information."
          />
          <meta property="og:image" content={`/studio/${ClaytonLogo}`} />
        </Head>
        <NotFoundContent addSiteUrl={true} internalLink={false} />
      </div>
    </StudioWrapper>
  );
};

export default NotFound;
